module.exports = __webpack_public_path__ + "static/media/nizar_square.5cc1d392.png";